"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Loader, ArrowRight } from "lucide-react";
const wp_query_params = {
  per_page: 4,
  product_tag: "42",
  status: "publish"
};
const wp_query = new WP_Query(wp_query_params);
function ProductCard({
  product,
  index
}: {
  product: any;
  index: number;
}) {
  const [isHovered, setIsHovered] = useState(false);
  const lifestyleImage = product.customFields?.lifestyle_image || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610560/img/eco_lifestyle_generic.png";
  return <div data-section-id="56444" data-index={index} className="group relative flex flex-col h-full rounded-none bg-card border border-border transition-all duration-300 hover:-translate-y-1 hover:shadow-xl" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {}
      <Link to={product.link} className="relative aspect-[4/5] w-full overflow-hidden rounded-none bg-muted">
        {}
        <img src={product.featured_image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610560/img/placeholder_product.png"} alt={product.title} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${isHovered ? "opacity-0" : "opacity-100"}`} loading="lazy" />
        {}
        <img src={lifestyleImage} alt={`${product.title} lifestyle`} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${isHovered ? "opacity-100" : "opacity-0"}`} loading="lazy" />
        
        {}
        <div className="absolute top-3 left-3 bg-primary text-primary-foreground text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest">
          Eco-Fabric
        </div>
      </Link>

      {}
      <div className="flex flex-col flex-grow p-6">
        <div className="mb-2">
          <h3 className="text-xl font-sans font-bold text-foreground leading-tight group-hover:text-primary transition-colors">
            <Link to={product.link}>{product.title}</Link>
          </h3>
          {product.categories && product.categories.length > 0 && <span className="text-xs text-muted-foreground font-medium uppercase tracking-widest">
              {product.categories[0].name}
            </span>}
        </div>

        {}
        <div className="mt-auto space-y-4">
          <div className="flex items-baseline justify-between border-t border-border/50 pt-4">
            <span className="font-sans text-2xl font-bold text-primary">
              ${product.price?.toFixed(2)}
            </span>
            {product.customFields?.unit && <span className="text-xs text-muted-foreground font-medium">
                / {product.customFields.unit}
              </span>}
          </div>

          {}
          <div className="pt-2">
            <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wider rounded-full h-12 transition-all hover:scale-[1.02] active:scale-95" text="Add to Cart" showQuantity={false} />
          </div>
        </div>
      </div>
    </div>;
}
function BestSellersGrid() {
  const {
    products,
    loading,
    error,
    refetch
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="aspect-[3/5] w-full animate-pulse rounded-none bg-muted/20" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-muted-foreground mb-4">Unable to load best sellers.</p>
        <button onClick={refetch} className="text-primary underline font-bold hover:text-primary/80">
          Try Again
        </button>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground font-medium">
        No trending items found at the moment.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <ProductCard key={product.id} product={product} index={i} />)}
    </div>;
}
export default function SustainableBestSellers() {
  return <section id="trending-sustainable-picks" className="bg-background text-foreground py-20 lg:py-28">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end md:mb-16">
          <div className="max-w-2xl">
            <h2 className="text-4xl font-sans font-bold tracking-tighter text-foreground sm:text-5xl md:text-6xl mb-4 uppercase">
              Trending Picks
            </h2>
            <p className="text-lg text-muted-foreground font-medium max-w-xl">
              High-performance gear engineered for the field and the planet. Explore our most-wanted sustainable staples for athletes and fans.
            </p>
          </div>
          <Link to="/ShopPage" className="group inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-primary hover:text-primary/80 transition-colors">
            View Full Collection
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        {}
        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        product_tag: [42],
        status: ["publish"]
      }} className="w-full">
          <BestSellersGrid />
        </EcommerceProductsProvider>
      </div>
    </section>;
}